module.exports = __webpack_public_path__ + "media/images/homes/Labelprinting-a36b5de079e503e30a973216b853a8cd.png";